import React from 'react'

export const CanvasAnimation = () => {
    const canvasRef = React.useRef(null)
    const particleArr  = []
    const color = "white"

    React.useEffect(()=>{
        const canvas = canvasRef.current
        const ctx = canvas.getContext("2d")

        class ParticleObj {
            constructor(x,y){
                // this.x = Math.random() * canvas.width
                // this.y = Math.random() * canvas.height
                this.x = x
                this.y = y
                this.color = color
                this.size = Math.random() * 5 + 4
                this.speedX = Math.floor(Math.random() * 4) - 1.5
                this.speedY = Math.floor(Math.random() * 4) - 1.5
            }

            update(){
                this.x += this.speedX
                this.y += this.speedY
                this.size -= 0.1
            }

            draw(){
                ctx.fillStyle = this.color
                ctx.beginPath()
                ctx.arc(this.x,this.y,this.size,0,Math.PI * 2)
                ctx.fill()
            }
        }

        window.document.body.addEventListener("mousemove",(e)=>{
            for(let c = 0;c< 5;c++){
                particleArr.push(new ParticleObj(e.clientX,e.clientY))
            }
        })
        
        const animate = ()=>{
            // ctx.fillStyle = "rgba(0,0,0,0.02)"
            // ctx.fillRect(0,0,canvas.width,canvas.height)
            ctx.clearRect(0,0,canvas.width,canvas.height)
            particleArr.forEach((v,i,arr)=>{
                v.update()
                if( v.size < 1.5){
                    arr.splice(i,1)
                }
            })
            particleArr.forEach(v=>{
                v.draw()
            })
            
            requestAnimationFrame(animate)
        }
        animate()
    })
  return (
    <canvas  ref={canvasRef} width={window.innerWidth} height={window.innerHeight} style={{position:"fixed",top:0,zIndex:-10}}></canvas>
  )
}

